<template>
  <div>
    <md-table
      :value="videos"
      md-height="100%"
      md-sort="name"
      md-sort-order="asc"
      md-card
      md-fixed-header
    >
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">videos</h1>
          <router-link :to="{name: 'newVideo'}">New Video</router-link>
        </div>
      </md-table-toolbar>

      <md-table-empty-state md-label="No videos found">
        <md-button class="md-primary md-raised" @click="newVideo">Upload new video</md-button>
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="ID" md-sort-by="_id">{{ item._id }}</md-table-cell>
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
        <md-table-cell md-label="Category" md-sort-by="category" v-if="item.category != null">{{ item.category.name }}</md-table-cell>
        <md-table-cell md-label="Category" md-sort-by="category" v-else></md-table-cell>

        <md-table-cell md-label="Actions">
          <router-link
            tag="md-button"
            :to="{ name: 'preview', params: { id: item._id} }"
            class="md-icon-button md-dense md-raised md-primary"
          >
            <md-icon><v-icon name="play" /></md-icon>
          </router-link>
          <router-link
            tag="md-button"
            :to="{ name: 'editVideo', params: { id: item._id} }"
            class="md-icon-button md-dense md-raised md-primary"
          >
            <md-icon><v-icon name="edit" /></md-icon>
          </router-link>
          <md-button
            @click="deleteItem(item._id)"
            class="md-icon-button md-dense md-raised md-accent"
          >
            <md-icon><v-icon name="trash" /></md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    search: null,
    searched: []
  }),
  computed: mapState({
    videos: state => state.videos
  }),
  mounted() {
    this.$store.dispatch("loadVideos");
  },
  methods: {
    newVideo() {
      this.$router.push({ name: "newVideo" });
    },
    deleteItem(id) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("deleteVideo", id).then(() => {
              this.$store.dispatch("loadVideos");
              this.$swal.fire({
                position: "center",
                type: "success",
                title: "Video has been deleted.",
                showConfirmButton: false,
                timer: 1500
              });
            });
          }
        });
    }
  }
};
</script>
